import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { InvydioState } from './invydio-session-types';
import { AsyncThunkConfig } from '../../async-thunk-config';
import apiManager from '../../../api/api-manager';

const initialState: InvydioState = {
  getSessionStatus: 'idle',
  invydioSessionStatus: 'NA',
  sessionId: undefined,
  workflowName: undefined,
};

export const getSessionStatusThunk = createAsyncThunk<
  string,
  string,
  AsyncThunkConfig<string>
>('session-status', async (sessionId: string, thunkApi) => {
  try {
    const response = await apiManager.dobCustomerApi.getInvydioSessionStatus(
      sessionId
    );
    return response.data?.code;
  } catch (error) {
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

const invydioSessionSlice = createSlice({
  name: 'features/invydioSession',
  initialState,
  reducers: {
    resetInvydioSessionState() {
      return initialState;
    },
    resetInvydioSessionStatus(state) {
      state.invydioSessionStatus = 'NA';
      state.getSessionStatus = 'idle';
    },
    setInvydioSession(state, action) {
      state.sessionId = action.payload;
    },
    setInvydioWorkflow(state, action) {
      state.workflowName = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSessionStatusThunk.pending, (state) => {
      state.getSessionStatus = 'loading';
    });
    builder.addCase(getSessionStatusThunk.fulfilled, (state, action) => {
      state.getSessionStatus = 'succeeded';
      state.invydioSessionStatus = action.payload !== '0' ? 'KO' : 'OK';
    });
    builder.addCase(getSessionStatusThunk.rejected, (state) => {
      state.invydioSessionStatus = 'KO';
      state.getSessionStatus = 'failed';
    });
  },
});

export const {
  resetInvydioSessionState,
  resetInvydioSessionStatus,
  setInvydioSession,
  setInvydioWorkflow,
} = invydioSessionSlice.actions;

export default invydioSessionSlice.reducer;
